export const data = [
    {
        title: 'Смотри везде',
        desc: 'Смотрите передачи на нескольких экранах одновременно.',
        action: '/domru-tv/watch-everywhere',
        textButton: 'Подробнее',
        background: 'linear-gradient(103.98deg, #21CC69 0%, #21CCC2 100%)',
    },
    {
        title: 'Управляй просмотром',
        desc: 'Перематывайте рекламу и ставьте прямой эфир на паузу.',
        action: '/catchup',
        textButton: 'Подробнее',
        background: 'linear-gradient(288.42deg, #FFB800 0%, #F4D900 100%)',
    },
    {
        title: 'Видеосервис Movix',
        desc: 'Смотрите фильмы и сериалы в одном месте и с любых устройств.',
        action: 'https://movix.ru/',
        textButton: 'Подробнее',
        background: 'linear-gradient(288.42deg, #9179F0 0%, #D079F0 100%)',
    },
];
